import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

interface ArenaHighlight {
  id: string;
  arena_id: string;
  arena_name: string;
  thumbnail_url: string | null;
  video_url: string | null;
  duration_seconds: number;
  participant_count: number;
  pop_count: number;
  highlight_type: "moment" | "match" | "trending";
  created_at: string;
}

export const useArenaHighlights = () => {
  const [highlights, setHighlights] = useState<ArenaHighlight[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchHighlights = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("arena_highlights")
      .select("*")
      .order("created_at", { ascending: false })
      .limit(20);

    if (!error && data) {
      setHighlights(data as ArenaHighlight[]);
    } else {
      setHighlights([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchHighlights();
  }, [fetchHighlights]);

  return {
    highlights,
    loading,
    refetch: fetchHighlights,
  };
};
